import PropTypes from 'prop-types';

var createClass = require('create-react-class');

window.InputSelectOption = createClass({
  propTypes: {
    name: PropTypes.string,
    value: PropTypes.node
  },

  render: function() {
    return <option value={this.props.value}>{this.props.name}</option>;
  }
});
